import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerBase } from '../../interfaces/answer-base.interface';
import { HabitsQuestion } from 'src/app/analyses/interfaces/analyses.types';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { GpuRadioGroupModule } from '@geneplanet/ngx-ui/src/lib/radio-group';
import { GpuFormFieldAppearance } from '@geneplanet/ngx-ui/src/lib/form-field';
import { controlContainerProvider } from '../../constants/control-container-provider';
import { AnswerDict } from '../../interfaces/answer-dict.interface';
import { AnswerDto } from '../../interfaces/answer-dto.interface';
import { AnalyticsService } from '@geneplanet/ngx-utils/src/lib/analytics';

@Component({
  selector: 'app-simple-options',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, GpuRadioGroupModule],
  templateUrl: './simple-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [controlContainerProvider],
})
export class SimpleOptionsComponent implements AnswerBase, OnDestroy {
  public questionnaireId: string;
  public question: HabitsQuestion;
  public formFieldAppearance: GpuFormFieldAppearance;
  public answer: AnswerDto;

  private parentContainer = inject(ControlContainer);
  private analyticsService = inject(AnalyticsService);

  get form() {
    return this.parentContainer.control as FormGroup;
  }

  public init(): void {
    this.form.addControl(
      'value',
      new FormControl(this.answer?.id ?? '', Validators.required)
    );
  }

  public onSubmit(): AnswerDict {
    return {
      [this.question.id]: [{ id: this.form.controls.value.value }],
    };
  }

  ngOnDestroy(): void {
    this.form.removeControl('value');
  }

  protected track(): void {
    this.analyticsService.trackFormValue(
      'analyses-add',
      'value',
      {
        id: this.form.controls.value.value,
      },
      this.questionnaireId,
      this.question.id
    );
  }
}
